<template>
  <v-card outlined>
    <v-card-title>{{ review.user_name }}</v-card-title>
    <v-card-subtitle>
      <v-rating
        v-if="review.rating || review.rating === 0"
        x-small
        dense
        readonly
        length="10"
        :value="review.rating"
      />
      <small>{{ $moment(review.created).fromNow() }}</small>
    </v-card-subtitle>
    <v-card-text>{{ review.review }}</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FilmReview',
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
}
</script>
